{
	"closed_title": "Anomalie chiuse",
	"columns": {
		"applications": "Domande inviate",
		"closed": "Chiusa il",
		"kind": "Tipo",
		"not_delivered": "Domande non consegnate",
		"note": "Nota",
		"open_anomalies": "Anomalie aperte",
		"opened": "Aperta il",
		"protocol": "Prot.",
		"reason": "Motivo",
		"residence": "Struttura"
	},
	"commands": {
		"close": "Chiudi",
		"close_description": "La nota resta con l'anomalia e nel registro. La domanda non cambia.",
		"close_done": "Anomalia chiusa.",
		"close_submit": "Chiudi con la nota",
		"close_title": "Chiudere l'anomalia",
		"note": "Nota",
		"note_required": "Scrivi perché la chiudi.",
		"notify": "Avvisa il gestore",
		"notify_done_one": "Email mandata a {{count}} gestore.",
		"notify_done_other": "Email mandata a {{count}} gestori."
	},
	"detail": {
		"basis": {
			"pec_arrival": "Arrivo alla PEC della struttura",
			"submitted": "Orario di invio della domanda"
		},
		"closed_note": "Anomalia chiusa: nessun comando disponibile.",
		"fields": {
			"closed": "Chiusa il",
			"effective": "Per il termine vale",
			"effective_basis": "Perché",
			"kind": "Tipo",
			"never": "Mai",
			"note": "Nota della chiusura",
			"notified": "Gestore avvisato il",
			"opened": "Aperta il",
			"protocol": "Protocollo",
			"reason": "Motivo tecnico",
			"recipient": "Indirizzo rifiutato",
			"residence": "Struttura",
			"submitted_at": "Firmata il"
		},
		"not_found": "Anomalia non trovata",
		"sections": {
			"anomaly": "Anomalia",
			"application": "Domanda",
			"commands": "Comandi"
		},
		"title": "Anomalia"
	},
	"empty_closed": "Nessuna anomalia chiusa",
	"empty_open": "Nessuna anomalia aperta",
	"filters": {
		"kind": "Tipo",
		"state": "Stato"
	},
	"kind": {
		"email_bounced": "Email rimbalzata",
		"offer_bounced": "Offerta non consegnata",
		"offer_not_sent": "Offerta non partita",
		"ranking_failed": "Calcolo non riuscito",
		"transmission_not_delivered": "Domanda non consegnata"
	},
	"no_residence": "Nessuna struttura",
	"open_title": "Anomalie aperte",
	"page_title": "Invii",
	"residences_empty": "Nessuna struttura",
	"residences_title": "Le strutture",
	"state": {
		"closed": "Chiuse",
		"open": "Aperte"
	},
	"without_residence": "Senza struttura: {{count}} anomalie aperte (email rimbalzate)"
}
